import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { GitProjectListComponent } from '../components/git-project-list.component';
export class GitProjectListModule {
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [CommonModule],
    declarations: [GitProjectListComponent],
    exports: [GitProjectListComponent]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function GitProjectListModule_tsickle_Closure_declarations() {
/** @type {?} */
GitProjectListModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
GitProjectListModule.ctorParameters;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
